module.exports = __webpack_public_path__ + "static/media/16UNODC21.5aa11ec5.jpg";